import React from 'react';
import { Phone, Mail, MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="md:col-span-1">
            <img 
              src="https://customer-assets.emergentagent.com/job_haul-away-pro/artifacts/lpx9fu7b_junkio.jpg" 
              alt="JUNKio Logo" 
              className="h-16 w-auto mb-4"
            />
            <p className="text-gray-400 mb-4">
              Hamilton's trusted junk removal service. Fast, affordable, and eco-friendly.
            </p>
            <div className="inline-flex items-center bg-emerald-600 px-4 py-2 rounded-lg">
              <span className="text-white font-semibold">Licensed & Insured</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <button onClick={() => scrollToSection('home')} className="text-gray-400 hover:text-emerald-400 transition-colors">
                  Home
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="text-gray-400 hover:text-emerald-400 transition-colors">
                  Services
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('pricing')} className="text-gray-400 hover:text-emerald-400 transition-colors">
                  Pricing
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="text-gray-400 hover:text-emerald-400 transition-colors">
                  Contact
                </button>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Our Services</h4>
            <ul className="space-y-2 text-gray-400">
              <li>Residential Junk Removal</li>
              <li>Commercial Junk Removal</li>
              <li>Furniture Removal</li>
              <li>Construction Debris</li>
              <li>Yard Waste Removal</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact Us</h4>
            <div className="space-y-3">
              <a href="tel:3653363364" className="flex items-center text-gray-400 hover:text-emerald-400 transition-colors">
                <Phone className="w-5 h-5 mr-2 flex-shrink-0" />
                <span>(365) 336-3364</span>
              </a>
              <a href="mailto:Info.junkio@gmail.com" className="flex items-center text-gray-400 hover:text-emerald-400 transition-colors">
                <Mail className="w-5 h-5 mr-2 flex-shrink-0" />
                <span>Info.junkio@gmail.com</span>
              </a>
              <div className="flex items-start text-gray-400">
                <MapPin className="w-5 h-5 mr-2 flex-shrink-0 mt-1" />
                <span>Hamilton, Ontario<br />& Surrounding Areas</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm mb-4 md:mb-0">
              &copy; {currentYear} JUNKio - Junk Removal. All rights reserved. | Licensed & Insured
            </p>
            <div className="flex space-x-6">
              <Link to="/privacy-policy" className="text-gray-400 hover:text-emerald-400 text-sm transition-colors">
                Privacy Policy
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;